export default {
  contactTerminals: {},
};
